import type { OutreachOperation } from '@discovr/types';
import { skipLabel } from './outreachSendCopy';

const SKIP_LABELS: Record<string, string> = {
  not_agreed: 'Rate not agreed yet',
  already_with_brand: 'Already with the brand',
  needs_you: 'Still needs you',
};

export const moveToBrandSkipLabel = (reason: string): string => SKIP_LABELS[reason] ?? skipLabel(reason);

/** "Moved 2 · skipped 1 (Rate not agreed yet 1) · failed 1" — the summary toast. */
export function moveToBrandSummary(operation: OutreachOperation): string {
  const parts = [`Moved ${operation.appliedCount}`];
  if (operation.skippedCount > 0) {
    const counts = operation.outcomes
      .filter((item) => item.outcome === 'skipped')
      .reduce<Record<string, number>>((acc, item) => {
        const reason = item.reason ?? 'unknown';
        return { ...acc, [reason]: (acc[reason] ?? 0) + 1 };
      }, {});
    const detail = Object.entries(counts).map(([reason, n]) => `${moveToBrandSkipLabel(reason)} ${n}`).join(', ');
    parts.push(`skipped ${operation.skippedCount}${detail ? ` (${detail})` : ''}`);
  }
  if (operation.failedCount > 0) parts.push(`failed ${operation.failedCount}`);
  return parts.join(' · ');
}
